import React from 'react';
import { StaticImageData } from 'next/image';
import ResultAImage from '@/assets/cultural/result-a.png';
import ResultCImage from '@/assets/cultural/result-c.png';
import ResultHImage from '@/assets/cultural/result-h.png';
import ResultMImage from '@/assets/cultural/result-m.png';

export const CULTURE_PREFERENCE_TEXT = [
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢与他人合作共同完成工作任务。',
      '我更喜欢独自一人完成工作任务。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我希望通过工作给予自己一定的约束力。',
      '我希望日常工作能够少点束缚，多点自由。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢在与同事有社交活动的环境中工作。',
      '我更喜欢在独立安静、不需要额外社交的环境中工作。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我希望在积极向上、充满活力的环境中工作。',
      '我希望在有一定压力的环境中工作以促进自我成长。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢在紧凑的时间内全力以赴，迅速解决问题并完成任务，以便有更多时间投入到其他重要的事务中。',
      '我更喜欢喜欢有足够的时间来仔细思考和执行工作，以确保工作的质量和准确性。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我希望领导能够给予我明确的下一步指示。',
      '我希望领导能够给予我更多的反思时间和自主发挥空间。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢清晰的管理规则与流程，以更好的工作。',
      '我不喜欢工作中有太多的条条框框和被严格定义的工作流程。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢有明确的责任范围和工作职责的团队，以避免工作任务的重叠或责任的模糊。',
      '我更喜欢可以灵活交叉在不同岗位工作的团队，以扩展自己的技能和知识。',
    ],
  },
  {
    title: '在工作中，你更倾向的考核方式是：',
    options: [
      '我更喜欢以量化指标或KPI的方式进行考核的团队。',
      '我更喜欢综合日常各个方面的表现进行考核的团队。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢专注于结果和成果的团队，以更好地发挥个人能力和实现工作目标。',
      '我更喜欢有明确的衡量指标和评估依据的团队，以清楚地了解自己的工作表现。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢通过与他人的交流互动进行自我学习与增长。',
      '我更喜欢通过自主学习和独立思考来进行自我提升，如视频学习、阅览书籍。',
    ],
  },
  {
    title: '在工作中，你更关注：',
    options: [
      '我更关注个人的成就与收获。',
      '我更关注团队的合作与参与、实现共同成果的过程。',
    ],
  },
  {
    title: '当团队中其他成员工作中出现失误时，你希望：',
    options: [
      '我希望通过教育及引导以避免他人再次出现失误。',
      '我希望按照公司中的规章制度对他人进行惩戒以避免再次出现失误。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢工作团队遵循统一的规则和流程，以确保工作的一致性和协调性。',
      '我更喜欢工作团队可以根据个人需求和特殊情况，给予成员一定的定制化和灵活性。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我会担心工作失误和存在的风险。',
      '我会优先考虑新想法的可行性，而不是担心失败或失误而畏手畏脚。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我喜欢领导者能够借鉴过去的经验和成功案例，在组织结构方面持谨慎态度。',
      '我喜欢敢于尝试新事物、新想法的领导，即使团队需要去不断适应新的工作方式和压力。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我希望领导能够直接、坦诚地指出我工作中存在的问题，以帮助我快速发现并解决这些问题，从而促进我的个人成长和提升。',
      '我希望领导能够以温和的方式指导我并给予我适当的帮助，帮助我意识到和解决工作中存在的问题。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢事先制定明确的计划，并且努力提前完成任务。',
      '我更喜欢根据工作需求来随时调整和优化工作计划。',
    ],
  },
  {
    title: '工作中遇到问题时，你倾向于：',
    options: [
      '我喜欢与团队直接共同讨论来解决工作中遇到的问题。',
      '我习惯先从自身找原因并尝试解决问题。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢团队定期对成员进行绩效评估和目标制定，以便成员持续提升和发展。',
      '我更喜欢没有特定的量化指标，以持续优化当前工作为方向的团队。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢能够实现自我预定的目标并取得积极的结果或可观收益的团队。',
      '我更喜欢员工可以在工作中得到长期成长及收获的团队。',
    ],
  },
  {
    title: '工作中，当团队中发生冲突或意见不一致时，你更倾向于：',
    options: [
      '我更喜欢通过与他人开放的对话和有效的沟通，共同找到解决问题的最佳方案。',
      '我更相信上级领导的权威和决策能力能够有效地解决困难情况，并提供更为确定性和组织化的解决方案。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢能够参与到团队的日常及重大决策中，为最终决策提供自己独特的观点和经验。',
      '我更喜欢按照领导的指示去执行工作，确保团队的目标得以实现。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '工作中的正面反馈和认可是我工作的动力。',
      '外界声音对我影响很小。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '团队合作和集体努力的氛围会激发我的工作热情和动力，让我更有动力去追求团队共同的成功目标。',
      '实际的奖励：如薪资增长、晋升机会或其他具体的激励措施，会激发我的工作动力和对工作的投入感。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我喜欢参加周期性的团建、年会以及日常的例会。',
      '我喜欢参加志愿者活动、学习培训等活动。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢通过自己的工作方法和时间管理策略开展工作，以确保高效地完成工作并达到预定的目标。',
      '我更喜欢与团队成员紧密合作、分享信息、协调工作，以高效实现共同的目标。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我更喜欢没有过多的层级关系和权威压力，每个人都可以自由地表达意见和建议的团队。',
      '我更喜欢上下级关系分明且具有明确的工作指导和管理的团队。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '我很乐意在工作中担任新的角色，接受新的挑战以实现自我更快地成长。',
      '非必要情况下，我不喜欢干本职工作以外的附加工作。',
    ],
  },
  {
    title: '在工作中，你更倾向于：',
    options: [
      '在工作中，我希望通过专业系统的培训与学习来提升自己的能力。',
      '我希望通过自己参与的诸多工作实践及经验累积进行自我提升。',
    ],
  },
];

export const CULTURE_PREFERENCE_TEXT_OPTION = [
  ['E', 'I'],
  ['C', 'F'],
  ['E', 'I'],
  ['F', 'C'],
  ['E', 'I'],
  ['I', 'E'],
  ['C', 'F'],
  ['C', 'F'],
  ['E', 'I'],
  ['I', 'E'],
  ['F', 'C'],
  ['C', 'F'],
  ['E', 'I'],
  ['C', 'F'],
  ['I', 'E'],
  ['I', 'E'],
  ['C', 'F'],
  ['C', 'F'],
  ['I', 'E'],
  ['E', 'I'],
  ['C', 'F'],
  ['F', 'C'],
  ['F', 'C'],
  ['E', 'I'],
  ['F', 'C'],
  ['C', 'F'],
  ['E', 'I'],
  ['F', 'C'],
  ['E', 'I'],
  ['I', 'E'],
];

export const CULTURE_PREFERENCE_TEAM_TYPE_PREFERENCE: Record<
  string,
  {
    bgColor: string;
    tagColor: string;
    image: StaticImageData;
    type: string;
    tag: string;
    desc: string;
    score: number[];
    keywords: string[];
    generalDesc: string[];
    feature: string[];
    suitTeam: string[];
    suitTeamKeys: string[];
    recommends: string[];
    suitOrigin: string[];
    unSuitTeam: string[];
    unSuitTeamKeys: string[];
    unSuitOrigin: string[];
  }
> = {
  A: {
    bgColor:
      'linear-gradient(180deg, #CEE4DB 0%, rgba(130, 179, 206, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-green-400',
    image: ResultAImage,
    type: '专业探索型团队',
    tag: '独立思考者',
    desc: '根据你的测试结果，你可能是<strong>“独立思考者”，善于解决工作中遇到的问题</strong>，从而达到高效率和高质量的工作成果<strong>。在面对挑战时，你不会轻易放弃</strong>，而是会积极寻找解决方案。你<strong>善于自我管理</strong>，能够在灵活的工作环境中找到自己的节奏，可以完美的适应各种环境和突发的状况。你对自己的工作充满热情，<strong>对自己热爱的专业领域有着深入的了解</strong>，同时也愿意不断学习来提高自己。在工作中，你<strong>勇于在必要时表达自己的观点</strong>。你在灵活和独立的工作环境中茁壮成长，时刻保持着学习和成长的心态，通过专业挑战和自主学习来让自己得到成长。',
    score: [6, 8, 8, 4],
    keywords: [
      '让人头疼的创新Party',
      '专业大咖',
      '鸭梨山大的高标准',
      '灵活自主',
      '弹性',
      '平等',
    ],
    generalDesc: [
      '专业探索型团队是一个<strong>充满活力和独立精神的集体</strong>。这个团队的工作节奏灵活，每个人都能根据自己的工作方式独立自主地进行工作。',
      '团队鼓励<strong>员工通过专业挑战和自主学习来实现自我成长</strong>；同时，团队决策主要基于专业知识和经验，有<strong>行业中的专业大咖带你一起成长</strong>。',
      '团队重视员工的贡献并以涨薪和优厚的福利待遇作为回报，同时也没有特定的惩罚方式。每个人在团队中都有发言权，你<strong>可以在大大小小的创新Party中脑洞大开、畅所欲言</strong>。',
      '工作考核主要通过工作进度评估和OKR考核来进行。',
      '总的来说，这是一个<strong>高要求</strong>且<strong>专业</strong>的团队，充满了挑战与快速成长的通道。',
    ],
    feature: [
      '工作专业化管理：专业探索型团队<strong>对成员有着高要求的期望和标准</strong>。他们<strong>注重每个成员的专业素质和能力，期望成员完全掌握自己的领域</strong>，并在工作中表现出色。如投资决策团队中的证券分析师，他们的独立研究和专业分析将成为投资决策的重要依据。',
      '工作节奏灵活：专业探索型团队的工作节奏较为自主灵活。在这样的团队中，团队<strong>成员被鼓励以自主和创新的方式完成工作，可以根据自己的节奏安排工作</strong>。如创业公司的团队，这样的团队会给予成员一定的自由度，让团队成员根据自己的工作风格和时间管理来安排任务的完成，以提高工作效率和质量。',
      '工作独立自主：专业探索型团队中的<strong>成员被赋予独立处理任务的能力和责任</strong>。每个成员可以根据自己的专业知识和经验，<strong>自主地解决问题和完成任务</strong>。以软件开发团队为例，团队成员将有机会独立负责设计和开发特定的模块，也可以根据自己的工作方法和创意进行独立的编码和测试。',
      '工作灵活自主开展：专业探索型团队鼓励并支持<strong>成员独立自主地处理任务和项目</strong>，同时允许<strong>成员在完成工作任务的前提下自由灵活地安排工作时间</strong>。在科研团队中，团队为成员提供设备和实验室资源，让每个成员独立进行科学研究并取得创新的科研成果。',
      '团队领导勇于变革：专业探索型团队的领导勇于变革，并且<strong>激励团队成员积极参与和贡献</strong>。在这个团队中，<strong>变革是前进的动力，不满足于现状，敢于挑战传统</strong>的做法并尝试新的方法是他们的特点。如马云意识到在数字化时代，传统的销售模式已不再适应市场需求，最终建立了享誉全球的阿里巴巴集团，打破了了中国原有的销售模式。',
      '团队成员成长方式多样化：专业探索型团队中的成员<strong>不仅可以通过专业上的挑战锻炼其专业能力，也可以进行自主学习以提升自我</strong>。如研发团队中的产品研发员，在参与研发新产品的同时遇到技术难题并寻找创新解决方案，通过自我查阅资料提升了专业能力。',
      '团队依据专业视角决策：专业探索型团队<strong>从专业视角出发，基于专业知识和经验做出决策</strong>。团队会深入研究市场、行业和竞争对手的趋势，并通过分析数据和评估风险来寻找最佳解决方案。如技术团队面临复杂的技术难题时，会与领先的专家和学者进行讨论和学习，并联合团队共同实施了一个快速原型验证，最终破解了技术难题。',
      '纯粹的同事关系：专业探索型团队成员之间有着纯粹的同事关系。这种<strong>以工作为主的交流方式</strong>让他们能够<strong>更专注于自己的工作</strong>，也让他们能够<strong>更好地理解和协调他人的工作</strong>。当项目团队接到一个新的项目时，每个人都会立即投入到自己的工作中。确保项目能够按时完成。他们之间的交流都是以工作为主，他们会互相分享自己的工作进展，也会互相讨论工作中遇到的问题。',
    ],
    suitTeam: [
      '<strong>创业团队：</strong>创业团队较为注重迭代速度及敏捷性，能够给予团队成员更大的自主权，为员工提供独立工作的机会和成长空间。',
      '<strong>研发团队：</strong>研发团队注重创新和技术突破，较为注重个人的自主性和创新思维。',
      '<strong>自由职业者团队：</strong>自由职业者组成的团队有极大的灵活性、自主性以及专业性，如自媒体、后期剪辑。',
      '<strong>创意设计团队：</strong>广告行业的创意团队注重创意和灵感，相对更灵活，注重创新而不是细节。',
      '<strong>科学研究团队：</strong>在科学领域，特别是实验室研究中，研究团队需要遵循严格的实验过程和准确的数据记录，以确保研究结果的可靠性和准确性。',
    ],
    suitTeamKeys: [
      '创业团队',
      '研发团队',
      '自由职业者团队',
      '创意设计团队',
      '科学研究团队',
    ],
    recommends: ['IT行业', '医药行业', '广告业', '市场推广', '建筑行业'],
    suitOrigin: [
      '<strong>独立且自由的工作状态：</strong>你在以上或与其类似的团队中工作时，虽然面临大量的专业挑战，但也有着诸多学习和发展机会。你不必耗费太多精力去思考繁琐烧脑的职场人际关系，独立且自由的工作状态能让你更好的实现自己的价值并保持较为愉悦的心情。',
    ],
    unSuitTeam: [
      '<strong>行政团队：</strong>行政类部门需要按照公司的规章制度及国家的法律法规开展工作，需要有条不紊地处理事务，如人事部、财务部等。',
      '<strong>风险管理团队：</strong>风险管理团队主要关注风险控制和合规性，确保财务交易的安全性和准确性。',
      '<strong>客户服务团队：</strong>客户服务团队需要有条理且细致地处理客户的问题，按照一定的流程和顺序提供解决方案，以提升客户满意度和服务质量。',
    ],
    unSuitTeamKeys: ['行政团队', '风险管理团队', '客户服务团队'],
    unSuitOrigin: [
      '<strong>流程繁琐：</strong>某些行政团队中有过多的流程和规定，使得工作变得复杂。对于更喜欢将精力放在核心任务和目标实现的人来说，这可能是一个不适合的选择。',
      '<strong>专业性较弱：</strong>客户服务团队的人员替代性较强，没有专业的技能支持自我的后续提升。对于想拥有一个专业性技能以确保职业生涯能够长线发展的人来说，这可能是一个不适合的选择。',
    ],
  },
  C: {
    bgColor:
      'linear-gradient(180deg, #F5F3C9 0%, rgba(125, 170, 112, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-amber-600',
    image: ResultCImage,
    type: '友善协作型团队',
    tag: '人情世故',
    desc: '根据你的测试结果，你可能是一个<strong>对工作有高度责任感</strong>的人，<strong>对自己的错误有清醒的认识，愿意接受批评并改正错误</strong>。在工作中，你能够沉着应对各种挑战，周密思考问题。你能够在压力下保持冷静，做出明智的决策。你尊重他人的观点，<strong>愿意倾听并接纳不同的意见</strong>。你善于协作，<strong>乐于分享自己的知识和经验，帮助团队成员解决问题</strong>，同时也愿意从他人那里学习，以实现自我成长。你愿意积极参与团队的决策过程，提出自己的观点和建议，但同时也接受团队的一致决策。',
    score: [2, 6, 2, 8],
    keywords: [
      '团队唠叨会',
      '协作疲劳症',
      '糖衣炮弹',
      '温情',
      '团结一心',
      '稳定',
    ],
    generalDesc: [
      '友善协作型团队<strong>以沉稳周密的工作节奏及和谐融洽的氛围为基石</strong>，通过成员之间的紧密协作，以确保工作的高效进行。',
      '团队<strong>重视并培养内部成员进行交流学习，鼓励员工不断成长和进步</strong>。',
      '团队面临决策时以讨论和一致决定为主，<strong>保证每个人的声音都能被听到</strong>。',
      '团队旨在赞扬优秀的员工并提供优厚的福利待遇，同时对小错误进行口头惩罚，以促进持续改进。团队的<strong>组织结构稳定，层级关系明晰</strong>，有利于形成高效的工作流程。',
      '工作考核方面更<strong>注重团队的整体表现</strong>而非个别表现，以此激发成员的团队精神。同时团队采取较为温和的指导式管理，以尊重和理解为导向，以帮助团队成员更好地完成工作。',
    ],
    feature: [
      '温和指导工作：友善协作型团队中领导通过温和的指导进行团队管理。这样的团队是<strong>温暖有力量</strong>的，在这样的环境中工作<strong>有助于团队成员的成长和发展</strong>。如领导者可能会定期与团队成员进行一对一的反馈和指导，对其提供支持和建议，帮助每一个成员克服困难并提高工作能力。',
      '工作节奏沉稳周密：友善协作型团队的工作节奏较为沉稳周密，<strong>不会盲目追求速度</strong>，而是<strong>更注重细节和质量</strong>。以新产品的开发为例，团队成员会花费大量时间进行市场调研，以确保产品能满足客户的需求。这种沉稳的工作节奏让你有足够的时间去深入思考，从而提高你的工作效率和质量。',
      '工作和谐融洽：友善协作型团队日常和谐融洽地开展工作。团队中<strong>每个人都会尊重其他人的意见</strong>，<strong>成员间会经常进行开放的讨论，分享彼此的想法和感受</strong>。团队成员之间通过友好的互动建立了良好的合作关系。如一支足球队在比赛中：前锋球员擅长射门进攻，中场球员善于传球组织，后卫球员具备优秀的防守能力。球员们彼此信任、相互配合，最终赢得一场比赛。',
      '工作中成员协作：友善协作型团队鼓励成员之间进行合作、协同工作。在这个团队中，每个成员都像一部精密的机器，<strong>各司其职却又互相配合无间</strong>。如建筑工地上的设计师、工程师、建筑师以及施工人员需要紧密合作，共同协调建筑工程的各个方面，确保工程项目按时完成。',
      '团队领导崇尚民主：友善协作型团队中领导十分注重团队成员的意见与参与，并鼓励成员积极参与决策讨论过程。在这样的团队中，你能感到<strong>自己的声音是被听到、被尊重、被重视的</strong>。在医疗团队中，医生、护士和其他医护人员会在诊断、治疗计划和手术方案上进行讨论，以确保最佳的病人护理结果。',
      '团队成员成长方式多样化：友善协作型团队中的成员可以<strong>通过团队内部的培养及互相交流学习，不断地提升个人能力和整体团队的素质</strong>。以音乐乐团为例，乐团中经验丰富的乐手会与新加入的乐手进行交流和指导。他们分享自己的经验、乐器技巧和音乐理论知识，帮助新成员快速适应团队的要求。通过团队内部的交流学习，团队成员共同成长，并提升乐团的整体音乐水平。',
      '团队讨论一致决策：友善协作型团队在决策前会进行充分的讨论与交流，以确保各方的观点被充分考虑。这个<strong>团队会寻求共识，并在达成一致意见后做出决策</strong>。如创意开发团队在负责为客户提供创新解决方案时，每个成员都可以分享自己的创意和想法，通过互相启发和协作，最终达成共识，制定出最佳的解决方案。',
      '工作伴随人情世故：友善协作型团队成员间<strong>关系融洽、彼此关系和尊重</strong>。在这样的团队中，你会在工作之外与同事间建立友谊、会关心每个人的生活、会在大家需要帮助时伸出援手。例如，当某一个同事生病时，其他成员会主动帮他分担工作，让他有更多的时间去休息。这种人情世故型的交往让团队更像一个大家庭，使得团队成员在工作中感到温暖和支持。',
    ],
    suitTeam: [
      '<strong>政府部门：</strong>政府部门的工作人员有强烈的团队精神以及耐心，以更好的服务群众。',
      '<strong>社会企业团队：</strong>社会企业团队致力于解决社会问题和推动社会变革。',
      '<strong>教育培训团队：</strong>教育培训团队致力于培养人才，提供教育和培训服务，促进个人和职业发展。',
      '<strong>产品开发团队：</strong>这类团队需要成员间的协作以及沉稳的工作模式，以确保产品的质量和研发进度。',
      '<strong>项目管理团队：</strong>项目管理团队负责项目管理、资源协调和绩效监控，从而有效地组织和协调各个项目的执行。',
    ],
    suitTeamKeys: [
      '政府部门',
      '社会企业团队',
      '教育培训团队',
      '产品开发团队',
      '项目管理团队',
    ],
    recommends: [
      '制造业',
      'IT行业',
      '电子商务',
      '教育行业',
      '建筑行业',
      '信息技术行业',
      '咨询行业',
    ],
    suitOrigin: [
      '<strong>长期稳定的工作发展：</strong>你在以上或与其类似的团队中工作时，面对每一个工作任务都需要沉稳与耐心的支持，充满温情的工作环境及长期稳定的发展能让你保持一个较为愉悦的心情和良好的工作状态。',
    ],
    unSuitTeam: [
      '<strong>销售团队：</strong>销售团队需要较强的沟通能力及抗压能力，与客户建立良好的关系并推动销售业绩。',
      '<strong>风险管理团队：</strong>风险管理团队主要关注风险控制和合规性，确保财务交易的安全性和准确性。',
      '<strong>研发团队：</strong>研发团队注重创新和技术突破，较为注重个人的自主性和创新思维。',
    ],
    unSuitTeamKeys: ['销售团队', '风险管理团队', '研发团队'],
    unSuitOrigin: [
      '<strong>高度竞争：</strong>销售团队通常存在激烈的内部及外部竞争，要求成员具备快速的反应力并能够对任务达成结果负责。对于不喜欢竞争及高压环境的人来说，这可能是一个不适合的选择。',
      '<strong>不确定性和风险：</strong>风险管理团队往往涉及到未知的困难与问题，这意味着有可能面临失败的风险、更大的挑战，可能需要承受较高的风险。对于喜欢长期稳定的工作环境的人来说，这可能是一个不适合的选择。',
    ],
  },
  H: {
    bgColor:
      'linear-gradient(180deg, #CFF2DC 0%, rgba(97, 137, 85, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-blue-400',
    image: ResultHImage,
    type: '精细流程型团队',
    tag: '规章机器人',
    desc: '根据你的测试结果，你可能是<strong>“时间追逐者”</strong>，一个极具责任感的人，你深知每一个任务的完成都对团队的整体运作有着重要影响。你<strong>以严谨的态度对待每一项工作，无论大小，都力求做到最好</strong>，但同时工作也会让你大脑中的弦时刻处于紧绷状态。你可能<strong>具有强烈的自我驱动力</strong>，并习惯在解决问题的过程中来提升自己。你<strong>缜密的逻辑思维</strong>也让人印象深刻。你会忘我地投入到工作中，<strong>无论面对多么复杂的任务，你都能保持冷静直至找到解决办法</strong>。尽管工作压力大、工作时间总会占用你大部分的休息时间，但你总能保持积极乐观的心态。',
    score: [4, 4, 4, 6],
    keywords: [
      '紧绷的弦',
      '赶鸭子上架',
      '领导的小跟班',
      '严谨',
      '有序',
      '精益求精',
    ],
    generalDesc: [
      '精细流程型团队<strong>以其紧凑的工作节奏和有条不紊的工作氛围著称</strong>，当然<strong>加班大概率是工作的常态</strong>。',
      '团队成员<strong>按章行事</strong>，遵守严格的规章制度。员工的成长方式全面且多元化，既可以从流程性的工作中得到成长，又有来自项目的挑战。',
      '主要由领导进行决策的方式，体现了<strong>垂直层级及流程化的团队组织结构</strong>。团队的<strong>奖惩方式主要体现在职位晋升及岗位调整上</strong>，鼓励员工积极投入工作。',
      '工作考核方式主要是日常流程考核以及KPI考核，如打卡全勤奖、业绩评估等，<strong>通过</strong>这些严格的<strong>考核方式将团队成员“赶鸭子上架”</strong>，以更好的进行团队的管理。',
      '总的来说，这是一个<strong>高效、严谨、有序</strong>的团队，充满了挑战与机遇。',
    ],
    feature: [
      '工作流程标准化：精细流程型团队在工作中遵循标准操作及流程。这样的团队是<strong>有序运作</strong>的，在这样的环境中工作<strong>有助于你发挥自己最大的潜力</strong>，同时也<strong>能帮助你提高工作效率并保证准确性和安全性</strong>。如飞行员需要严格按照飞行手册的规定进行飞行，任何一点小小的疏忽都可能导致严重的后果。',
      '工作节奏紧凑：精细流程型团队的工作节奏较为紧凑，<strong>即使加班也必须完成任务</strong>。在这样的团队中，<strong>每个项目及工作任都需要在规定的时间内完成</strong>。如新闻编辑部每天都有新的新闻需要及时报道，你会在这样的环境中以较大的工作强度开展工作，你也会面临更大的挑战。',
      '工作有条不紊：精细流程型团队日常有条不紊地开展工作。这样的团队是<strong>职责清晰</strong>的，每个团队成员都知道自己的责任和角色，大家都<strong>按照计划和流程完成工作</strong>。如医院的手术室中，每个医生和护士对自己的职责都有明确的认知，按照既定的步骤进行手术，这样可以确保手术的顺利进行，避免出现混乱和错误。',
      '工作按章行事：精细流程型团队平时严格按照规章制度进行团队及工作管理。这样的团队可以给你<strong>清晰明确的指导</strong>，以<strong>减少你工作中的混乱和误解</strong>。如公司的目标是减少生产成本，那么规章制度可能会规定员工需要使用哪一种更经济的材料或者更有效的生产方式。这样的规定可以直接指导员工的工作，让员工更清楚地知道其需要做什么，以及如何去做。',
      '团队领导精益求精：精细流程型团队中<strong>领导对下属的工作完成情况精益求精、领导极具有风险规避意识</strong>。这样的团队环境会让你在工作中更加谨慎、更加注重细节，以减少可能的错误和风险。如生物科技公司的领导者会在项目的每个阶段都进行详细的风险评估和管理，以确保项目的顺利进行。在研究新的生物药物过程中，团队成员需要不断地进行实验和研究并优化方案，以求达到最好的效果。',
      '团队成员成长方式多样化：精细流程型团队中的<strong>成员可以在规定的框架内发挥创新，在遇到挑战时也可以有所学习和成长</strong>。以汽车制造公司的工程师为例，既定的流程确保工程师在设计和制造汽车的过程中不会出错。如果公司当下的目标是设计一款新的电动汽车，那么工程师也需要学习和掌握电动汽车的相关知识来进行自我提升。',
      '团队领导为主要决策者：精细流程型团队在决策时以领导意见为主。领导作为主要决策人的团队开展工作更有序，更有效。所有的决策都由领导做出，成员可以<strong>在明确的指示下更快更好地进行工作</strong>，而<strong>不需要在决策过程中花费太多的时间</strong>。如一家医疗设备公司中重大的决策：如项目的方向、产品的设计等，都由领导做出。这样的环境能让研发工程师更专注于擅长的技术研发工作，而不需要分心去考虑决策问题。',
      '团队工作中上下级分明：精细流程型团队上下层级分明。在这样的团队中，你可以在明确的职责及领导的指导下更好地完成手头的工作，同时也<strong>能让你更清楚地了解自己担任的角色和期望</strong>。例如，如果你在工作中遇到问题，可以直接向你的上级寻求帮助，而不需要在团队中寻找合适的人。',
    ],
    suitTeam: [
      '<strong>风险管理团队：</strong>风险管理团队主要关注风险控制和合规性，确保财务交易的安全性和准确性。',
      '<strong>生产制造部门：</strong>生产工作通常都需要严格遵守工艺流程，以确保产品的质量和生产的效率。',
      '<strong>客户服务团队：</strong>客户服务团队需要有条理且细致地处理客户的问题，按照一定的流程和顺序提供解决方案，以提升客户满意度和服务质量。',
      '<strong>行政团队：</strong>行政类部门需要按照公司的规章制度及国家的法律法规开展工作，需要有条不紊地处理事务，如人事部、财务部等。',
      '<strong>工程团队：</strong>工程项目需要按照一定的流程进行，因此工程团队成员需要严格遵循规定的工作方式来保证项目的顺利进行。',
    ],
    suitTeamKeys: [
      '风险管理团队',
      '生产制造部门',
      '客户服务团队',
      '行政团队',
      '工程团队',
    ],
    recommends: [
      '金融行业',
      '制造业',
      '电子商务',
      '软件开发',
      '医疗行业',
      '通信行业',
      '建筑业',
    ],
    suitOrigin: [
      '<strong>工作清晰有序：</strong>你在以上或与其类似的团队中工作时，每一个工作细节中都有着规章制度的约束，工作中每个步骤都清晰明确，细致且略微繁琐的工作状态能让你更好的实现自己的价值并保持较为愉悦的心情。',
    ],
    unSuitTeam: [
      '<strong>创意设计团队：</strong>广告行业的创意团队注重创意和灵感，相对更灵活，注重创新而不是细节。',
      '<strong>创业团队：</strong>创业团队较为注重迭代速度及敏捷性，能够给予团队成员更大的自主权，为员工提供独立工作的机会和成长空间。',
      '<strong>研发团队：</strong>研发团队注重创新和技术突破，较为注重个人的自主性和创新思维',
    ],
    unSuitTeamKeys: ['创意设计团队', '创业团队', '研发团队'],
    unSuitOrigin: [
      '<strong>高度竞争：</strong>创新研发团队通常存在激烈的竞争，要求成员具备高度的技术能力和创造力。对于不喜欢竞争或不习惯于高压环境的人来说，这可能是一个不适合的选择。',
      '<strong>不确定性和风险：</strong>创新研发类团队往往涉及到未知领域和新技术的开发。这意味着有可能面临失败、挑战和不确定的进展，可能需要承受较高的风险。对于喜欢稳定和流程可预测性的人来说，这可能是一个不适合的选择。',
    ],
  },
  M: {
    bgColor:
      'linear-gradient(180deg, #EDE2F2 0%, rgba(206, 182, 220, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-[#FF2D96]',
    image: ResultMImage,
    type: '任务竞争型团队',
    tag: '目标猎人',
    desc: '根据你的测试结果，你可能是一个<strong>“目标猎人”</strong>，在工作中你<strong>紧跟目标</strong>，不断提升自己的工作效率和质量，以达成优秀的工作绩效。你具备<strong>良好的抗压能力</strong>：面对高压力的任务，你不会轻易崩溃，而是能够保持冷静，<strong>有效地管理和调整自己的情绪和压力</strong>。同时，你也能够在复杂的环境中做出明智的决策，以实现最佳的工作效果。你有<strong>快速的思维和说干就干的行动力</strong>，能够在紧张的工作节奏中快速做出决策，<strong>快速应对各种突发情况</strong>。你有着强烈的竞争意识和进取心，能够在竞争激烈的环境中保持积极的态度，并不断提升自己，以实现个人和团队的目标。',
    score: [8, 2, 6, 2],
    keywords: [
      '人员风暴',
      '同事角斗场',
      '业绩狂潮',
      '激情',
      '高压力',
      '高效执行力',
    ],
    generalDesc: [
      '任务竞争型团队是一个充满了活力和竞争力的团队。团队中的<strong>成员以迅雷不及掩耳之速推进工作</strong>，每一次的决策都是<strong>以最终的绩效达成结果为导向</strong>。',
      '在这里，竞争不只是一种氛围，更是一种激励，团队的<strong>奖惩方式直接与任务完成比例挂钩</strong>，这进一步激发了团队成员的工作热情和责任感。',
      '每个团队成员都紧跟目标，通过在<strong>高压力的任务下进行自我学习，以提升自身的能力和业绩</strong>。',
      '这个团队中<strong>人员更迭的速度很快</strong>，这意味着每个人都必须时刻保持最佳状态，像一场<strong>没有终点的马拉松</strong>，只有不断超越自我、超越他人，才能在这个团队中立足。',
    ],
    feature: [
      '业绩考核管理：任务竞争型团队在工作中采用严格的业绩考核方式进行管理。这样的团队是比较公平的，<strong>每个人的工作绩效都会被明确地量化和评估</strong>。如销售团队的业绩会根据他们的销售额来衡量。这种管理方式能够让团队中每一个成员都清楚地知道自己的工作目标，并且更有动力去提高自己的工作效率。',
      '工作节奏快速：任务竞争型团队的工作节奏十分快速。这个团队通过<strong>迅速工作以响应项目及市场需求</strong>，以<strong>快速行动和执行力</strong>见长，始终<strong>保持高度的敏捷性和适应能力</strong>。如电商团队在双11大促时，团队成员会迅速编写活动页面的文案，设计吸引人的海报，同时启动广告投放和社交媒体推广。整个过程很迅速，团队成员需要在短时间内完成大量的工作。',
      '工作活跃积极：任务竞争型团队有着活跃积极的工作氛围。团队成员都充满活力和竞争意识，他们<strong>互相激发动力，追求个人和团队的优秀表现</strong>。在销售团队中，每个成员都在竞争激烈的市场中争取业绩和客户。在这个团队中，成员之间相互压力和激励，努力超越对方，以成为团队中的佼佼者。',
      '工作注重目标设定及追踪：任务竞争型团队注重目标的设定和追踪。成员清楚团队的目标及使命，并采取相应的行动来实现它们，在<strong>面临挑战和困难时也不轻言放弃，始终保持对目标的关注和追求</strong>。在一家制造企业中，生产工人按照预定的生产计划，精确制造产品，确保按时交付客户。',
      '团队根据现实结果做出决策：任务竞争型团队<strong>基于成员的绩效结果来做出决策</strong>，推动团队成员不断努力，提升绩效并实现团队目标。在足球队中，教练和管理层会根据球员的表现和比赛结果来做出决策。比如，谁在训练中表现出色、谁在比赛中发挥突出，可能会在下一场比赛中获得更多的上场机会。',
      '团队成员自我驱动成长：任务竞争型团队中的成员<strong>在高压力下自我激励、持续学习，追求卓越和创新，能够不断迭代、提升自己</strong>，以适应竞争激烈和快速变化的工作环境。一个紧急救援团队，他们在救援任务中经常面临压力和挑战。团队成员会自觉提升自己的技能，不断参加培训和研讨会，学习最新的救援技术和应对策略。他们自觉推动自己在高压力环境下的学习和成长，以提供更好的救援服务。',
      '团队领导以任务达成为首要目标：任务竞争型团队注重目标的达成和结果的交付。这样的团队非常<strong>注重任务的完成和成果的产出</strong>、进而<strong>追求高效和优质的工作成果</strong>。如生产制造企业会注重生产线的运作效率和产品的质量，将任务的完成和业绩的达成放在首位。',
      '团队工作中充满竞争：任务竞争型团队中<strong>存在着一定的内部及外部竞争关系</strong>。在这样的团队中，可以激发你的积极性，从而让你得到快速的成长及收获。例如，销售人员都会有自己的销售目标，他们需要通过彼此之间的竞争来提高自己的销售业绩，以达到或超过自己的销售目标获得提成，同时也能够锻炼自己。',
    ],
    suitTeam: [
      '<strong>销售团队：</strong>销售团队需要较强的沟通能力及抗压能力，与客户建立良好的关系并推动销售业绩。',
      '<strong>市场营销团队：</strong>市场营销团队负责市场推广、销售策略和客户关系管理，能够制定有效的市场营销策略并推动品牌的发展。',
      '<strong>渠道管理团队：</strong>渠道管理团队负责与分销商、代理商、经销商等建立合作关系，并确保产品或服务能够顺利地通过渠道销售。',
      '<strong>销售支持团队：</strong>销售支持团队负责准备销售材料和文档、处理销售订单、跟进销售进展以及提供销售数据和报告等。',
      '<strong>客户服务团队：</strong>客户服务团队需要有条理且细致地处理客户的问题，按照一定的流程和顺序提供解决方案，以提升客户满意度和服务质量。',
    ],
    suitTeamKeys: [
      '销售团队',
      '市场营销团队',
      '渠道管理团队',
      '销售支持团队',
      '客户服务团队',
    ],
    recommends: [
      '房地产行业',
      '建筑行业',
      '医药行业',
      '数字营销',
      '金融行业',
      'IT行业',
      '制造业',
    ],
    suitOrigin: [
      '<strong>灵活适应市场环境：</strong>你在以上或与其类似的团队中工作时，快速的工作节奏和竞争活跃的工作氛围可以激励你时刻保持高度的警觉性和积极性，以便快速响应市场变化，以让你更好的实现自己的价值。',
    ],
    unSuitTeam: [
      '<strong>政府部门：</strong>政府部门的工作人员需要具备强烈的团队精神以及耐心，以更好的服务群众。',
      '<strong>行政团队：</strong>行政团队需要按照公司的规章制度及国家的法律法规开展工作，需要有条不紊地处理事务，如人事部、财务部等。',
      '<strong>项目管理团队：</strong>项目管理团队负责项目管理、资源协调和绩效监控，从而有效地组织和协调各个项目的执行。',
    ],
    unSuitTeamKeys: ['政府部门', '行政团队', '项目管理团队'],
    unSuitOrigin: [
      '<strong>挑战不大、成长缓慢：</strong>政府部门的工资及福利待遇相对于私营企业来说较低，且晋升机会有限。对于喜欢挑战并通过自己的努力获得高回报的人来说，这可能是一个不适合的选择。',
      '<strong>“繁文缛节”流程较为严重：</strong>行政团队通常有一套繁文缛节的程序或政策，以确保内部公正透明。但对于不喜欢被束缚和一成不变的人来说，这可能是一个不适合的选择。',
    ],
  },
  AM: {
    bgColor:
      'linear-gradient(180deg, #CEE4DB 0%, rgba(130, 179, 206, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-green-400',
    image: ResultAImage,
    type: '专业开拓型团队',
    tag: '创新怪兽',
    desc: '根据你的测试结果，你可能是<strong>“环境适应者”，能够迅速适应不同的工作环境和变化的情况</strong>。你<strong>对新事物和新技术保持着敏锐的兴趣，并愿意主动学习和探索</strong>。你具备良好的学习能力和问题解决能力，<strong>能够迅速掌握新知识和技能，并将其应用到实际工作中</strong>。你善于对管理时间和资源进行管理，<strong>合理安排工作优先级，并迅速采取行动</strong>。你愿意接受他人的反馈和指导，并将其用于改进自己的工作表现。你对工作充满热情，始终保持乐观的态度，即使面临挑战和压力，也能保持坚韧和冷静。',
    score: [7, 4, 7, 3],
    keywords: [
      '找茬高手',
      '冒险狂魔',
      '跳火圈专家',
      '活跃',
      '应变力',
      '专业素养',
    ],
    generalDesc: [
      '<strong>专业开拓型团队</strong>是一种高度活跃和充满激情的团队，他们<strong>专注于市场开拓和业务扩展</strong>。',
      '这个团队的<strong>工作节奏较快，经常面临市场竞争激烈的环境</strong>，需要团队成员快速作出决策和行动，以抓住机会并满足客户需求。',
      '团队鼓励成员不断学习和发展自己的能力；同时，团队决策是灵活的，<strong>每个人在团队中都有发言权</strong>，在这里你的声音可以被听到或被采纳。',
      '工作考核<strong>主要根据实际业绩和完成的目标来评估成员的工作表现</strong>。',
      '总的来说，这是一个<strong>高效、积极、有活力</strong>的团队，能够迅速应对市场挑战并获得成功。',
    ],
    feature: [
      '工作扁平开放化管理：专业开拓型团队的管理方式<strong>注重激励和支持</strong>。团队管理者为成员提供必要的资源和支持，帮助他们克服困难和挑战。他们也<strong>鼓励成员有自主性和创新性，并提供必要的反馈和指导</strong>。例如，项目管理团队的管理者会与团队成员定期开展项目进展会议，提供必要的资源和支持，并跟踪项目的进展和问题解决过程。',
      '工作节奏较快：专业开拓型团队<strong>通常以较快的节奏开展工作</strong>。他们面临竞争激烈的市场环境，需要<strong>迅速抓住机会并作出决策行动</strong>。例如，销售团队在推出新产品时，需要迅速调整营销策略、制定销售计划，并快速响应市场反馈，以实现销售目标。',
      '工作积极向上：专业开拓型团队<strong>注重积极向上的工作氛围</strong>。团队成员之间<strong>建立了合作和支持的关系，共同追求团队的目标</strong>。他们互相激励、分享经验和知识，并共同解决问题。例如，在营销团队中，成员之间会积极交流市场信息、竞争动态和客户洞察，以共同制定市场拓展策略。',
      '工作注重结果及效率：专业开拓型团队<strong>注重结果和效率</strong>。他们设定明确的目标，并制定详细的工作计划和时间表。团队成员<strong>按照计划执行任务，并及时进行反馈和调整</strong>。例如，技术团队在开发新产品时，会制定详尽的项目计划，明确各项任务和里程碑，并定期进行进度评估和跟踪，以确保项目按时交付。',
      '团队领导对成员鼓励式引导：专业开拓型团队的领导者<strong>通常是激励和激发成员的导师</strong>。他们鼓励成员发挥自己的潜力，给予他们信任和支持，并提供必要的指导和反馈。如业务开发团队的领导者会激励成员积极寻找新商机，并为他们提供资源和支持，以帮助他们实现销售目标。',
      '团队成员持续成长：专业开拓型团队<strong>鼓励成员不断学习和成长</strong>。他们<strong>提供培训机会、参加行业会议和研讨会等，以增加成员的专业知识和技能</strong>。团队成员也通过面对挑战和接触新项目来锻炼自己。如营销团队会定期组织内部培训和分享会，以提升团队成员的市场营销能力和商业洞察力。',
      '团队灵活决策：专业开拓型团队采用灵活的决策模式。他们<strong>注重团队合作和集体智慧，鼓励成员参与决策过程，并充分听取各种意见和建议</strong>。在创新团队中，成员会集思广益，共同讨论和评估不同的创意和解决方案，以选择最佳的决策路径。',
      '团队成员彼此互助：在专业开拓型团队中，<strong>成员之间建立了积极的合作关系和互相支持的氛围</strong>。他们相互信任、尊重和理解，并愿意分享知识和经验，以促进团队的成功。跨部门合作的团队会鼓励不同部门的成员合作，共同解决问题，并通过知识分享和协作来实现项目目标。',
    ],
    suitTeam: [
      '<strong>创业团队：</strong>创业团队较为注重迭代速度及敏捷性，能够给予团队成员更大的自主权，为员工提供独立工作的机会和成长空间。',
      '<strong>研发团队：</strong>研发团队注重创新和技术突破，较为注重个人的自主性和创新思维。',
      '<strong>自由职业者团队：</strong>自由职业者组成的团队有极大的灵活性、自主性以及专业性，如自媒体、后期剪辑等。',
      '<strong>运营团队：</strong>运营团队负责管理和协调业务活动，确保组织高效地运营。',
      '<strong>销售团队：</strong>销售团队需要较强的沟通能力及抗压能力，与客户建立良好的关系并推动销售业绩。',
    ],
    suitTeamKeys: [
      '创业团队',
      '研发团队',
      '自由职业者团队',
      '运营团队',
      '销售团队',
    ],
    recommends: ['IT行业', '医药行业', '电子商务', '房地产行业', '建筑行业'],
    suitOrigin: [
      '<strong>无畏失败的工作状态：</strong>你在以上或与其类似的团队中工作时，虽然面临专业及市场的挑战，但也有着诸较多的发展机会和成功概率。你可以努力去闯、去尝试，无所畏惧的工作状态能让你更好的实现自己的价值并保持较为愉悦的心情。',
    ],
    unSuitTeam: [
      '<strong>维护团队：</strong>维护团队主要负责维护和保养已有系统或设备，发展机会有限。工作可能相对稳定，但缺乏创新和挑战性。',
      '<strong>政府部门：</strong>政府部门的工作人员需要具备强烈的团队精神以及耐心，以更好的服务群众。',
      '<strong>产品开发团队：</strong>这类团队需要成员间的协作以及沉稳的工作模式，以确保产品的质量和研发进度。',
    ],
    unSuitTeamKeys: ['维护团队', '政府部门', '产品开发团队'],
    unSuitOrigin: [
      '<strong>流程繁琐：</strong>某些行政团队中有过多的流程和规定，使得工作变得复杂。对于更喜欢将精力放在核心任务和目标实现的人来说，这可能是一个不适合的选择。',
      '<strong>固化的流程及决策：</strong>某些政府部门中通常具有较为刻板的规章制度和决策层级，对于更喜欢积极主动、创新适应的人来说，这可能是一个不适合的选择。',
    ],
  },
  MA: {
    bgColor:
      'linear-gradient(180deg, #EDE2F2 0%, rgba(206, 182, 220, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-[#FF2D96]',
    image: ResultMImage,
    type: '行动专业派团队',
    tag: '效率狂魔',
    desc: '根据你的测试结果，你可能是<strong>“效率狂魔”</strong>，你具有<strong>高度的专业素养，行动力强且追求效率，具有强烈的责任感</strong>。你是<strong>实干家</strong>，而不是空谈家。<strong>你相信“行动胜于空谈”，并且始终坚持“实践是检验真理的唯一标准”</strong>。你是专业的追求者，深信只有专业的人才能做好专业的事情。你擅长制定明确的目标和计划，并按计划行事，力求在最短的时间内完成最高质量的工作。<strong>你认为只有实际的结果才能证明自己的工作成果</strong>。你具备较强的执行力和决断力，在面对问题时能够迅速做出决策并采取行动。你有较高的自我驱动力和责任心，能够主动承担任务和职责，并积极推动团队的工作。',
    score: [9, 3, 9, 1],
    keywords: [
      '责任感爆棚',
      '结果控',
      '专业界的疯子',
      '冒险家',
      '即时迅猛',
      '开拓',
    ],
    generalDesc: [
      '行动专业派团队是一种<strong>以实际行动为主，专业技能为基础，注重追求效率和明确结果</strong>的团队。',
      '在这个团队中，成员都具备扎实的专业知识和技能，并能够将其<strong>应用于实际行动</strong>中。',
      '<strong>团队注重实际行动和最终结果的实现，团队成员不仅仅是理论专家，也会通过迅速行动来解决问题。</strong>',
      '团队会通过<strong>定期的绩效评估和反馈机制</strong>来考核团队成员的表现。总的来说，这种团队有助于团队成员的个人发展和团队的整体成长。',
    ],
    feature: [
      '工作激励化管理：行动专业派团队的管理者通常<strong>采用激励措施来激发团队成员的积极性和工作动力</strong>。他们提供资源和支持，帮助团队成员克服困难和挑战，并为他们创造一个积极向上的工作环境。如部门经理会定期与团队成员进行一对一的反馈和指导，帮助他们解决问题并提供必要的培训和发展机会。',
      '工作节奏快速高效：行动专业派团队通常<strong>以快节奏和高效率著称</strong>。团队<strong>注重任务的执行和完成，追求优质的工作成果</strong>。如销售团队每天都有明确的销售目标和计划安排，团队成员紧密合作，迅速响应客户需求，以确保销售任务按时完成。',
      '工作专业积极：工作氛围专业且积极是行动专业派团队的关键组成部分。这种团队通常<strong>注重开放和透明的沟通，鼓励成员之间分享信息、想法和意见</strong>。例如，开发团队鼓励成员之间的沟通和知识分享，通过定期举行技术研讨会和团队建设活动，促进团队成员之间的交流和合作。',
      '工作以实际行动为先：行动专业派团队倾向于采取实际行动和解决问题的方法。他们<strong>注重执行力和结果导向，善于制定具体的行动计划，并积极践行</strong>。例如，项目团队在面对紧急任务时，会快速组织会议讨论解决方案，并迅速分配任务并展开行动，以确保项目进展顺利。',
      '团队领导开放赋能：行动专业派团队领导开放式管理。行动专业派团队的领导者<strong>鼓励团队成员发挥自己的能力，给予他们自主决策的权力</strong>。领导者关注成员的发展和成长，提供支持和指导，并为团队成员创造良好的工作环境。如项目经理会鼓励团队成员提出创新的解决方案，并给予他们在项目中领导和决策的机会，以激发团队成员的积极性和创造力。',
      '团队成员成长方式多样化：行动专业派团队鼓励团队成员不断学习和提升自己的专业能力。团队通常<strong>提供学习资源和培训机会，支持成员参与外部培训和学习活动</strong>。例如，咨询团队提供定期的培训和知识分享机会，鼓励成员参与外部培训和学习活动，以提升他们的专业能力和知识水平。',
      '团队依据共识决策：行动专业派团队通常采取团队决策的方式，鼓励成员参与决策过程，分享不同的观点和意见。团队<strong>成员之间进行讨论和协商，寻求共识，并根据团队目标和优先级做出决策</strong>。如市场团队在制定营销策略时，组织团队会议进行头脑风暴，并通过讨论和协商达成共识，确保团队的决策符合整体目标。',
      '团队成员彼此合作支持：行动专业派团队成员之间通常建立<strong>积极的合作和支持关系</strong>，相互帮助和互补。例如，在研发团队中的成员经常互相交流和合作，共同解决技术难题，以提高团队的整体效能。例如，研发团队中的成员经常互相交流和合作，共同解决技术难题，以提高团队的整体效能。',
    ],
    suitTeam: [
      '<strong>销售团队：</strong>销售团队需要较强的沟通能力及抗压能力，与客户建立良好的关系并推动销售业绩。',
      '<strong>运营团队：</strong>运营团队负责管理和协调业务活动，确保组织高效地运营。',
      '<strong>创业团队：</strong>创业团队较为注重迭代速度及敏捷性，能够给予团队成员更大的自主权，为员工提供独立工作的机会和成长空间。',
      '<strong>市场营销团队：</strong>市场营销团队负责市场推广、销售策略和客户关系管理，能够制定有效的市场营销策略并推动品牌的发展。',
      '<strong>自由职业者团队：</strong>自由职业者组成的团队有极大的灵活性、自主性以及专业性，如自媒体、后期剪辑。',
    ],
    suitTeamKeys: [
      '销售团队',
      '运营团队',
      '创业团队',
      '市场营销团队',
      '自由职业者团队',
    ],
    recommends: ['房地产行业', '建筑行业', '医药行业', 'IT行业', '电子商务'],
    suitOrigin: [
      '<strong>机会与风险并存：</strong>当你在这样的团队中工作时，虽然会面临来自市场环境的挑战和失败的风险，但也会有更多的发展机会和成功的可能性。你可以积极努力、勇于尝试，勇敢地向前走，这种状态将使你更好地实现自我的理想与抱负。',
    ],
    unSuitTeam: [
      '<strong>社会企业团队：</strong>社会企业团队致力于解决社会问题和推动社会变革。',
      '<strong>政府部门：</strong>政府部门的工作人员需要具备强烈的团队精神以及耐心，以更好的服务群众。',
      '<strong>质量控制部门：</strong>质量控制部门在制造业或生产流程中的质量控制团队工作，负责确保产品符合质量标准和规范要求，需要注重细节和精确性。',
    ],
    unSuitTeamKeys: ['社会企业团队', '政府部门', '质量控制部门'],
    unSuitOrigin: [
      '<strong>流程繁琐、决策固化：</strong>某些政府行政团队注重规章制度的执行和权威的话语权，在决策时更为保守，缺乏灵活性和创新性。对于在工作中不喜欢被条条框框束缚的人来说，这可能是一个不适合的选择。',
      '<strong>发展空间受限：</strong>传统产业团队可能对变革和创新的接受度较低，对于富有创新思维和追求的人来说，发展空间可能有限。',
    ],
  },
  AC: {
    bgColor:
      'linear-gradient(180deg, #CEE4DB 0%, rgba(130, 179, 206, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-green-400',
    image: ResultAImage,
    type: '探索合作型团队',
    tag: '团队灵魂人物',
    desc: '根据你的测试结果，你可能是<strong>“团队的灵魂人物”</strong>，一个<strong>积极主动、具有创造力及合作精神</strong>的人。你<strong>对新事物充满好奇心、勇于面对挑战</strong>，并且乐于尝试新的解决方案。你具有<strong>开放的思维方式</strong>，能够接受不同的观点和意见，愿意与他人进行合作和协商以找到最佳的解决方案。你具备<strong>良好的沟通和协作能力</strong>，能够与团队成员有效地交流和合作。在工作中，你<strong>善于倾听他人的意见和建议，并能够表达自己的观点和想法</strong>。你是一个强自我驱动且有追求的人。在团队中，你能够充分发挥自己的潜力，为团队的合作与创新做出积极的贡献。',
    score: [5, 8, 5, 5],
    keywords: [
      '创新达人',
      '团队精神发电机',
      '探索过渡者',
      '和谐',
      '合作共赢',
      '探究',
    ],
    generalDesc: [
      '探索合作型团队是一个<strong>富有创造力且具有团队意识</strong>的团队，这个团队的工作节奏通常充满活力和变化。',
      '团队成员被鼓励提出新的想法和解决方案，<strong>团队强调集体合作和交流</strong>。',
      '团队成员通常会在项目中分工协作，共同解决问题。成员间乐于分享知识和经验，以促进团队和自我的整体成长。',
      '<strong>团队强调公正和激励</strong>，成员优秀的表现会得到奖励，而不良的行为会得到改正。',
      '工作考核方式通常是综合考量：他们<strong>关注团队成员的实际表现和贡献</strong>，而<strong>不仅仅是他们的努力程度</strong>。良好的团队关系是成功的关键，在这里，你会感受到职场中久违的友谊和互助。',
    ],
    feature: [
      '工作扁平化管理：探索合作型团队的管理方式倾向于<strong>扁平化和自主管理。管理者会给予团队成员更大的自主权和决策权，鼓励他们发挥创造力和创新能力</strong>。他们会提供资源和支持，以满足团队成员的需求，并及时解决问题。例如，创意团队的管理者会为团队成员提供必要的资源和培训，同时允许他们自由发挥创意和实施创新项目。',
      '工作节奏活跃且灵活：探索合作型团队通常以活跃而灵活的工作节奏进行工作。团队成员会充分利用时间，<strong>灵活安排任务和分工，以便更好地协同合作</strong>。产品团队致力于开发新产品，他们会以较快的节奏进行设计、实验和迭代，以满足市场需求。',
      '工作积极开放：探索合作型团队营造积极、开放的工作氛围。团队成员之间<strong>相互鼓励和支持，共享知识和经验</strong>。他们<strong>鼓励创新思维和新想法的表达</strong>，并乐于接受不同观点的挑战。例如，创业团队的成员会在团队会议上分享自己的创意和见解，其他成员则会提供反馈和建议，以促进团队的合作和创新。',
      '在实践中协作开展工作：探索合作型团队倾向于采用<strong>协作和实践</strong>的工作方式。<strong>团队成员积极合作，共同解决问题并实施计划</strong>。他们鼓励团队成员承担不同的角色和责任，以充分发挥个人的专长和技能。如项目团队在开发新产品时，成员会紧密合作，共同完成各自的任务，确保项目按时交付。',
      '团队领导开明上进：探索合作型团队的领导者通常是开明和具有支持性的。他们<strong>鼓励团队成员的积极参与和创新思维，提供支持和指导</strong>，以促进团队的合作和发展。如研究团队的领导者会鼓励成员提出新的研究方向和实验方法，并提供资源和支持，以推动团队的科研成果。',
      '团队成员成长方式多样化：在探索合作型团队中，团队成员<strong>不仅可以通过实践和学习进行成长，同时，他们也会通过分享和反馈，从他人的经验中学习和成长</strong>。例如，研究团队的成员会定期组织学术研讨会，互相分享最新的研究成果和发现，并共同探讨研究问题。',
      '团队民主决策：探索合作型团队通常采用民主和共识的决策模式。团队成员会积极参与决策过程，分享自己的意见和建议。他们<strong>鼓励开放的讨论和辩论，以达成共识和最佳解决方案</strong>。政府机构的部门在制定策略决策时，会组织多轮讨论和投票，以确保每个成员的声音都被听到。',
      '团队成员合作互助：在探索合作型团队中，成员之间通常建立<strong>积极的合作关系和互助关系</strong>。团队成员会相互支持和帮助，共同解决问题和克服困难。他们鼓励<strong>开放的沟通和有效的团队合作</strong>，以实现共同的目标。如跨部门团队的成员会定期召开会议，分享进展和交流问题，以促进彼此之间的理解和合作。',
    ],
    suitTeam: [
      '<strong>研发团队：</strong>研发团队注重创新和技术突破，较为注重个人的自主性和创新思维。',
      '<strong>创意设计团队：</strong>广告行业的创意团队注重创意和灵感，相对更灵活，注重创新而不是细节。',
      '<strong>科学研究团队：</strong>在科学领域，特别是实验室研究中，研究团队需要遵循严格的实验过程和准确的数据记录，以确保研究结果的可靠性和准确性。',
      '<strong>项目管理团队：</strong>项目管理团队负责项目管理、资源协调和绩效监控，从而有效地组织和协调各个项目的执行。',
      '<strong>社会企业团队：</strong>社会企业团队致力于解决社会问题和推动社会变革。',
    ],
    suitTeamKeys: [
      '研发团队',
      '创意设计团队',
      '科学研究团队',
      '项目管理团队',
      '社会企业团队',
    ],
    recommends: [
      'IT行业',
      '广告业',
      '建筑业',
      '建筑行业',
      '信息技术行业',
      '咨询行业',
    ],
    suitOrigin: [
      '专业的成长：</strong>这类型的团队为你提供了一个良好的工作环境，让你能够专注于自己的研究领域，使你的专业知识和技能更进一步。这种持续的专业研究有助于你拓宽自己的专业视野，同时为你提供了持续进步和个人成就的动力。',
    ],
    unSuitTeam: [
      '<strong>风险管理团队：</strong>风险管理团队主要关注风险控制和合规性，确保财务交易的安全性和准确性。',
      '<strong>财务部门：</strong>在会计、审计或财务分析团队中工作，能够与数字和细节密切相关，执行严格的财务流程和标准。',
      '<strong>法律团队：</strong>在法律事务所或企业法务部门工作，处理合同起草、法律研究和风险管理等任务，需要对法律细节和法规合规性有高度关注。',
    ],
    unSuitTeamKeys: ['风险管理团队', '财务部门', '法律团队'],
    unSuitOrigin: [
      '<strong>复杂性和不确定性：</strong>风险管理团队通常涉及处理各种复杂的风险情景和不确定性因素。这需要综合考虑多个因素，包括市场变化、政治环境、技术发展等。对于不喜欢冒险和遵循标准化流程的人来说，这可能是一个不适合的选择。',
      '<strong>时间压力和紧急情况：</strong>法律团队的工作通常面临时间紧迫的压力，尤其在处理紧急情况和法律纠纷时。对于不喜欢竞争或不习惯于高压环境的人来说，这可能是一个不适合的选择。',
    ],
  },
  CA: {
    bgColor:
      'linear-gradient(180deg, #F5F3C9 0%, rgba(125, 170, 112, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-amber-600',
    image: ResultCImage,
    type: '温情开拓型团队',
    tag: '创新小能手',
    desc: '根据你的测试结果，你可能是<strong>“创新小能手”</strong>，你是一个充满同理心、勇于创新且充满活力的人。你总<strong>愿意倾听他人的观点，尊重他人的想法</strong>，以自己的理解和接纳来维护团队的和谐氛围。你拥有强烈的探索精神，<strong>对于新的想法和挑战总是充满热情</strong>。你<strong>敢于挑战自我</strong>，超越常规，无惧失败，因为你知道，只有通过不断地尝试和学习，才能找到最佳的解决方案。你是团队的动力源，你的存在让团队更加团结紧密，更有活力。你有着乐观积极的心态，让团队在面对困难和挑战时能够保持坚定的信念和决心。',
    score: [3, 7, 3, 7],
    keywords: [
      '团结就是力量',
      '会议狂魔',
      '大大的决策拼图',
      '信任',
      '舒适',
      '同心协力',
    ],
    generalDesc: [
      '温情开拓型团队是一个充满热情和温暖的团队，团队<strong>致力于开拓创新、追求卓越</strong>。',
      '团队中每个成员都有着多元化的背景和技能且十分热爱自己的工作，并为团队的成功而努力。',
      '团队成员<strong>具备良好的沟通和合作能力</strong>，每个成员都被鼓励发表自己的观点和想法以及创新和尝试新的方法来解决问题。',
      '<strong>团队注重成员的发展和成长</strong>，并为其提供培训和学习机会，鼓励团队成员不断学习和提升自己的技能。',
      '团队鼓励成员积极参与社会公益活动，传递温暖和爱心。这个<strong>团队在工作中秉持着诚信、责任和承诺的价值观</strong>，通过<strong>专业和细致的工作</strong>不断为社会创造更多的价值和意义。',
    ],
    feature: [
      '工作关怀式管理：温情开拓型团队的管理方式<strong>注重个人关怀和支持</strong>。团队<strong>领导者关注成员的福祉和工作需求</strong>，提供必要的资源和支持。例如，团队会定期与成员进行一对一的会议，了解他们的工作进展和困难，提供帮助和解决方案。他们也会关注成员的工作负荷和平衡，确保他们的工作环境和条件良好。',
      '“健康”的工作节奏：温情开拓型团队强调平衡工作与生活，<strong>倡导健康的工作节奏</strong>。团队成员相互尊重工作时间和个人需求，避免过度加班和疲劳。团队成员会<strong>共同制定合理的工作时间表，确保每个人都有足够的休息和放松时间</strong>。团队领导者也会关注成员的工作负荷，避免过度压力和疲劳。这样的团队注重员工身心健康，以提高工作效率和团队凝聚力。',
      '工作积极支持：温情开拓型团队有着积极、支持和鼓励的工作氛围。团队<strong>成员之间建立信任和互助关系，倡导开放的沟通和知识分享</strong>。在这样的团队中，成员可以自由地表达自己的观点，而不会受到批评或指责。团队领导者鼓励成员之间相互支持和赞赏，营造积极的工作氛围。',
      '工作独立开展：温情开拓型团队鼓励成员展现创造力和独立思考。<strong>团队成员被赋予一定的自主权和决策权</strong>，可以自主管理和组织工作。如开发团队可能鼓励成员参与决策和项目规划。成员也可以选择适合自己的工作方法和流程，以提高工作效率和创造力。',
      '团队领导民主：温情开拓型团队的领导者通常十分注重民主。他们<strong>倾听团队成员的意见和需求</strong>，激发成员的潜力和创造力。领导者<strong>鼓励开放的沟通和反馈</strong>，提供支持和指导，帮助团队成员实现个人和团队目标。如团队领导者可能定期与成员进行一对一的沟通，了解他们的工作需求和职业发展计划。他们会提供良好的反馈和指导，并鼓励成员参与决策和项目管理。',
      '团队成员在工作中成长：温情开拓型团队<strong>注重成员的个人成长和职业发展</strong>。团队成员获得培训和学习机会，提升技能和知识。团队鼓励成员设定个人目标，并为其提供支持和反馈，帮助实现目标。例如在技术团队中会组织定期的培训课程、研讨会或分享会，帮助成员学习新的技能或了解行业趋势。同时团队领导者也会定期与成员进行评估和反馈，帮助他们发现个人优势以及改进方向。',
      '团队依据合作及共识决策：温情开拓型团队倡导合作和共识的决策模式。<strong>团队成员参与决策过程，分享意见和建议，并通过讨论和协商达成共识</strong>。团队注重集体智慧和团队共同决策的力量。例如，团队在需要做出重要决策时，成员可以在开放的讨论环境中分享观点和建议。团队领导者引导讨论，确保每个人有机会发表意见，并最终达成团队共识。',
      '团队成员间凝聚力强：温情开拓型团队注重建立积极的成员关系和团队凝聚力。团队<strong>鼓励团队建设活动和团队合作项目，提升成员之间的联系和合作</strong>。团队可以组织团队建设活动，如团队组织成员进行户外拓展训练或社交聚会，加强成员之间的信任和合作。',
    ],
    suitTeam: [
      '<strong>项目管理团队：</strong>项目管理团队负责项目管理、资源协调和绩效监控，从而有效地组织和协调各个项目的执行。',
      '<strong>人力资源团队：</strong>人力资源团队负责招聘、培训发展、员工关系等人力资源管理方面的工作。',
      '<strong>社会企业团队：</strong>社会企业团队致力于解决社会问题和推动社会变革。',
      '<strong>研发团队：</strong>研发团队注重创新和技术突破，较为注重个人的自主性和创新思维。',
      '<strong>创业团队：</strong>创业团队较为注重迭代速度及敏捷性，能够给予团队成员更大的自主权，为员工提供独立工作的机会和成长空间。',
    ],
    suitTeamKeys: [
      '项目管理团队',
      '人力资源团队',
      '社会企业团队',
      '研发团队',
      '创业团队',
    ],
    recommends: ['建筑行业', '信息技术行业', '咨询行业', 'IT行业', '医药行业'],
    suitOrigin: [
      '<strong>“多任务”处理：</strong>当你在这样的团队中工作时，虽然可能会面临同时进行多个任务或项目的挑战，但能够对未来的职业发展打下坚实的基础。你可以积极努力、勇于尝试，“放开手脚”地工作，这样的团队能够给你带来职业满足感与成就感。',
    ],
    unSuitTeam: [
      '<strong>信息安全团队：</strong>信息安全团队负责确保组织的信息系统和数据的合规性和安全性。',
      '<strong>销售团队：</strong>销售团队需要较强的沟通能力及抗压能力，与客户建立良好的关系并推动销售业绩。',
      '<strong>客户服务团队：</strong>客户服务团队需要有条理且细致地处理客户的问题，按照一定的流程和顺序提供解决方案，以提升客户满意度和服务质量',
    ],
    unSuitTeamKeys: ['信息安全团队', '销售团队', '客户服务团队'],
    unSuitOrigin: [
      '<strong>风险及合规的定时审查：</strong>信息安全团队注重不同的规章制度和法律法规的执行，在决策时更为细致，缺乏灵活性和创新性。对于在工作中不喜欢被各种制度束缚的人来说，这可能是一个不适合的选择。',
      '<strong>专业性较弱：</strong>客户服务团队的人员替代性较强，没有专业的技能支持自我的后续提升。对于想拥有一个专业性技能以确保职业生涯能够长线发展的人来说，这可能是一个不适合的选择。',
    ],
  },
  MH: {
    bgColor:
      'linear-gradient(180deg, #EDE2F2 0%, rgba(206, 182, 220, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-[#FF2D96]',
    image: ResultMImage,
    type: '精细拓展型团队',
    tag: '速度之王',
    desc: '根据你的测试结果，你可能是<strong>“速度之王”</strong>，你充满了<strong>活力</strong>和<strong>进取心</strong>。你对工作充满热情，积极参与团队活动，你<strong>善于制定任务优先级</strong>，具备灵活性和适应性，<strong>能够在压力下保持冷静</strong>，并快速作出决策和调整。作为一个<strong>自我驱动的学习者</strong>，你主动寻求学习机会，不断提升自己的技能和知识。你愿意投入时间和精力进行自主学习，并通过实践和经验积累不断成长。你<strong>具备自我管理的能力</strong>，能够有效地规划和管理自己的学习和发展路径。你追求卓越，在工作中不满足于平庸，不断挑战自我并超越自我。',
    score: [7, 1, 5, 3],
    keywords: [
      '目标狂魔',
      '决策急先锋',
      '自我升级专家',
      '组织',
      '效率第一',
      '有章法',
    ],
    generalDesc: [
      '精细拓展型团队以<strong>高效运作、积极发展和良好的成员关系</strong>为特点。团队成员在快节奏的工作环境中努力工作，同时<strong>保持着热忱活跃的工作氛围</strong>。',
      '团队<strong>注重目标设定和追踪</strong>，并通过自发学习和成长来促进成员的个人发展。',
      '团队决策是基于任务达成的，领导鼓励并支持成员的参与和长期发展。',
      '工作<strong>考核方式基于绩效评估</strong>，以评估成员的工作表现和贡献。团队会设定明确的绩效指标，并定期进行评估和反馈。这样可以帮助成员了解他们的强项和发展领域，并为个人和团队的进步提供指导。',
      '这个团队<strong>成员间相互支持</strong>，形成了<strong>良性的内部竞争</strong>，以达到共同的目标。',
    ],
    feature: [
      '绩效评估管理：精细拓展型团队采用绩效评估的方式进行管理。团队根据绩效评估结果，<strong>制定个人发展计划和激励措施</strong>，以促进员工的成长和发展。管理者还会<strong>协调团队资源，确保任务的分配和执行高效有序</strong>。如在一个客户服务团队中，管理者会根据客户满意度调查和反馈评估员工的服务质量，并提供培训和支持，以提高客户服务的水平。',
      '工作节奏较快：精细拓展型团队以较快的工作节奏著称。团队习惯于<strong>在紧迫的时间压力下工作</strong>，并能够<strong>高效地应对任务和项目的需求变化</strong>。无论是面临紧急的截止日期还是突发的挑战，团队成员都能够迅速适应并采取行动，确保任务按时完成。例如，在市场营销团队中，他们经常面临各种紧急的市场推广活动，需要在短时间内制定计划、策划活动，并迅速执行，以抓住市场机会。',
      '工作热忱活跃：精细拓展型团队的工作氛围热忱活跃。成员间互相激励，共同追求团队目标的实现。团队<strong>成员之间的沟通频繁且直接</strong>，鼓励开放和坦诚的反馈。他们<strong>共享知识和经验</strong>，相互学习和成长。例如，在创意团队中，成员们会积极讨论和分享各自的创意和观点，相互启发，并共同努力创造出优秀的创意作品。',
      '工作注重目标设定及追踪：精细拓展型团队在工作中注重目标设定和追踪，以确保工作的准确性和高效性。成员们<strong>明确任务目标</strong>，并制定相应的计划和策略。他们<strong>跟踪任务的进展，并根据实际情况进行调整和决策</strong>。例如，在软件开发团队中，他们会在项目启动阶段明确项目的目标和里程碑，并制定详细的开发计划。团队成员会定期检查项目进展，确保开发工作按计划进行，并及时调整策略以应对可能的风险和挑战。',
      '团队领导追求卓越：精细拓展型团队的领导追求卓越。领导者设定高标准，并提供支持和资源，以<strong>帮助团队成员实现个人和团队目标</strong>。领导者激发团队成员的潜力，<strong>鼓励创新和创造力</strong>。例如，在研发团队中，领导者会激励团队成员追求技术创新和产品质量的卓越，鼓励他们超越传统的界限，推动技术的进步。',
      '团队成员自发成长：精细拓展型团队鼓励成员自发地学习和成长。<strong>成员主动寻求学习的机会</strong>，不断提升自己的技能和知识。他们<strong>参加培训课程、研讨会</strong>，并通过实践和经验积累提升自己的专业能力。在研究院中，成员们会定期阅读最新的研究论文，参加学术会议，并积极参与学术讨论，以不断拓展自己的研究领域和知识深度。',
      '团队以任务达成情况决策：精细拓展型团队的决策模式基于任务的达成情况。成员<strong>通过评估任务的进展和结果，共同决策最佳的方案和行动计划</strong>。这种决策模式确保了团队行动的准确性和有效性。如在销售团队中，他们会根据销售数据和市场反馈评估销售策略的效果，并基于这些评估结果调整销售计划和目标。',
      '团队有“规矩”的竞争：精细拓展型团队<strong>成员间保持着在一定规矩设定内的竞争关系</strong>。他们相互激励，争取在团队中脱颖而出。这种竞争关系促使成员们不断提高自己的能力和表现，同时也推动整个团队的发展。销售团队中，成员们会竞争性地争取更多的销售业绩，以获得奖励和认可。',
    ],
    suitTeam: [
      '<strong>销售团队：</strong>销售团队需要较强的沟通能力及抗压能力，与客户建立良好的关系并推动销售业绩。',
      '<strong>市场营销团队：</strong>市场营销团队负责市场推广、销售策略和客户关系管理，能够制定有效的市场营销策略并推动品牌的发展。',
      '<strong>质量控制部门：</strong>质量控制部门在制造业或生产流程中的质量控制团队工作，负责确保产品符合质量标准和规范要求，需要注重细节和精确性。',
      '<strong>数据分析团队：</strong>数据科学分析团队负责处理大量数据并提供准确的洞察和决策支持，需要细致入微的数据分析能力。',
      '<strong>渠道管理团队：</strong>渠道管理团队负责与分销商、代理商、经销商等建立合作关系，并确保产品或服务能够顺利地通过渠道销售。',
    ],
    suitTeamKeys: [
      '销售团队',
      '市场营销团队',
      '质量控制部门',
      '数据分析团队',
      '渠道管理团队',
    ],
    recommends: [
      '房地产行业',
      '建筑行业',
      '医药行业',
      '金融行业',
      'IT行业',
      '电子与通信',
      '生产制造业',
    ],
    suitOrigin: [
      '竞争中展现自我：</strong>在这样的团队中工作可以激发你的潜能，提供机会让你在竞争中展现自己的能力，并实现自身的价值。然而，你也需要遵守相应的规则和制度，以确保竞争是健康、公平和有益的。',
    ],
    unSuitTeam: [
      '<strong>创意设计团队：</strong>广告行业的创意团队注重创意和灵感，相对更灵活，注重创新而不是细节。',
      '<strong>产品开发团队：</strong>这类团队需要成员间的协作以及沉稳的工作模式，以确保产品的质量和研发进度。',
      '<strong>维护团队：</strong>维护团队主要负责维护和保养已有系统或设备，发展机会有限。工作可能相对稳定，但缺乏创新和挑战性。',
    ],
    unSuitTeamKeys: ['创意设计团队', '产品开发团队', '维护团队'],
    unSuitOrigin: [
      '<strong>新颖的创新思维：</strong>在创意设计团队中需要有新颖的创新点以产出作品。在这个环境中工作需要具备创新的精神、高效工作和良好的团队合作能力。对于喜欢按照一定的流程来开展工作的人来说，这可能是一个不适合的选择。',
      '<strong>高度专业协作能力：</strong>产品开发团队需要具备良好的沟通和协作能力以及极高的专业素养，以有效地协调开展各个团队的工作，确保项目顺利进行。对于不是很喜欢深入研究技能类的人来说，这可能是一个不适合的选择。',
    ],
  },
  HM: {
    bgColor:
      'linear-gradient(180deg, #CFF2DC 0%, rgba(97, 137, 85, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-blue-400',
    image: ResultHImage,
    type: '合规开拓型团队',
    tag: '无间道职场',
    desc: '根据你的测试结果，你可能是一个严谨细致的人，你<strong>对工作持有高度的责任感</strong>，在工作中严格遵守规定和标准，同时也会<strong>主动探索跟进新的行业发展</strong>。你会<strong>对工作细节进行深入挖掘</strong>，确保操作的合规性。你的谨慎和细致性可以保证你不会忽视任何可能的合规风险。你<strong>有着强烈的责任感和敬业精神</strong>。你的责任感推动你不断努力，以确保在工作中达到最高标准。你<strong>有着严密的逻辑思维和分析能力</strong>，以便能够评估各种合规选项和风险，并做出明智的决策。',
    score: [5, 2, 3, 5],
    keywords: [
      '绩效过山车',
      '时间空洞',
      '加班成了生活常态',
      '审慎',
      '秩序井然',
      '信心',
    ],
    generalDesc: [
      '合规开拓型团队就像是<strong>“无间道”</strong>，以<strong>快节奏、细致谨慎</strong>的工作氛围为特色，<strong>严格按章行事</strong>，追求卓越。',
      '团队成员的成长方式多元化，既有流程性的学习，又有来自项目的挑战和内部的学习机会，以确保员工的全面发展。',
      '在决策模式上，团队<strong>坚持按照规章制度决策</strong>，保证每一项决定都是在充分考虑和讨论后作出，以实现最佳结果。',
      '奖惩方式以职位晋升和岗位调整为主，以此激励团队成员持续提升自我，实现更高的工作目标。',
      '团队的<strong>组织结构清晰</strong>，层级分明，<strong>流程化的管理模式使工作更加高效有序</strong>。',
      '团队的管理方式<strong>以规章制度为主导</strong>，确保每一项工作都在规定的框架内进行，以此保障团队的稳定和高效运行。',
    ],
    feature: [
      '工作流程标准化：合规开拓型团队<strong>在工作中遵循标准操作及流程</strong>。这样的团队是<strong>有序运作</strong>的，在这样的环境中工作有助于你发挥自己最大的潜力，同时也能<strong>帮助你提高工作效率并保证准确性和安全性</strong>。如飞行员需要严格按照飞行手册的规定进行飞行，任何一点小小的疏忽都可能导致严重的后果。',
      '工作节奏较快：合规开拓型团队的工作节奏较快。团队<strong>成员需要迅速响应和调整工作计划</strong>，以确保合规性的实现。如在金融机构的合规团队中，他们需要及时调整合规策略，以应对新的金融监管法规。',
      '工作细致谨慎：合规开拓型团队日常细致谨慎的开展工作。团队成员对法规和政策文件进行详尽审查，确保组织行为的合规性。他们<strong>具有高度的责任感和敬业精神</strong>。例如，在医药公司的合规团队中，团队成员会仔细审查新药研发过程中的合规性要求，以确保公司的研发活动符合相关法规。',
      '工作按章行事：合规开拓型团队平时严格按照规章制度进行团队及工作管理。这样的团队可以给你<strong>清晰明确的指导</strong>，以<strong>减少你工作中的混乱和误解</strong>。如公司的目标是减少生产成本，那么规章制度可能会规定员工需要使用哪一种更经济的材料或者更有效的生产方式。这样的规定可以直接指导员工的工作，让员工更清楚地知道其需要做什么，以及如何去做。',
      '团队领导精益求精：合规开拓型团队中<strong>领导对下属的工作完成情况精益求精</strong>。团队成员在工作中十分<strong>谨慎、注重细节</strong>，以减少可能的错误和风险。如生物科技公司的领导者会在项目的每个阶段都进行详细的风险评估和管理，以确保项目的顺利进行。在研究新的生物药物过程中，团队成员需要不断地进行实验和研究并优化方案，以求达到最好的效果',
      '团队成员成长方式多样化：合规开拓型团队中成员需要持续学习。团队<strong>成员需要不断更新自己的知识和技能</strong>，以跟上时代及行业的变化。他们可能会参加培训课程、专业认证或行业研讨会等。例如，在一家科技公司的数据隐私合规团队中，团队成员会接受数据保护法规的培训，并不断学习最新的隐私保护技术。',
      '团队依据规章及风险性决策：合规开拓型团队<strong>基于合规性和风险规避的方向进行决策</strong>。团队会充分评估各种风险和影响，并依据规章制度和最佳实践做出决策。如一家汽车制造公司的环境合规团队中，他们会基于环境保护法规和可持续发展原则，制定公司的环境管理政策。',
      '团队成员在竞争中合作：合规开拓型团队的成员之间<strong>不仅仅是竞争关系，也是合作关系</strong>。团队成员共同为实现目标而努力，彼此间也存在着竞争，以促进团队工作的开展。如在制药公司的销售团队中，团队成员之间会相互协作，确保公司的销售额目标达成，同时成员间也会有业绩的竞争与淘汰。',
    ],
    suitTeam: [
      '<strong>财务部门：</strong>在会计、审计或财务分析团队中工作，能够与数字和细节密切相关，执行严格的财务流程和标准。',
      '<strong>风险管理团队：</strong>风险管理团队主要关注风险控制和合规性，确保财务交易的安全性和准确性。',
      '<strong>项目管理部门：</strong>项目管理团队负责规划、执行和监控项目进展，需要注重细节、遵循项目管理方法和保持项目的稳定性。',
      '<strong>法律团队：</strong>在法律事务所或企业法务部门工作，处理合同起草、法律研究和风险管理等任务，需要对法律细节和法规合规性有高度关注。',
      '<strong>市场营销团队：</strong>市场营销团队负责市场推广、销售策略和客户关系管理，能够制定有效的市场营销策略并推动品牌的发展。',
    ],
    suitTeamKeys: [
      '财务部门',
      '风险管理团队',
      '项目管理团队',
      '法律团队',
      '市场营销团队',
    ],
    recommends: [
      '金融行业',
      'IT行业',
      '教育行业',
      '咨询行业',
      '医药行业',
      '市场营销',
    ],
    suitOrigin: [
      '<strong>良性的竞争关系：</strong>你在以上或与其类似的团队中工作时，虽然存在着一定的竞争，但是在规章制度的约束下会形成较为良性的竞争关系。这类型的团队不仅强调细致和明确的工作步骤，同时也能为你提供实现个人价值的机会。',
    ],
    unSuitTeam: [
      '<strong>创意设计团队：</strong>广告行业的创意团队注重创意和灵感，相对更灵活，注重创新而不是细节。',
      '<strong>研发团队：</strong>研发团队注重创新和技术突破，较为注重个人的自主性和创新思维。',
      '<strong>创业团队：</strong>创业团队较为注重迭代速度及敏捷性，能够给予团队成员更大的自主权，为员工提供独立工作的机会和成长空间',
    ],
    unSuitTeamKeys: ['创意设计团队', '研发团队', '创业团队'],
    unSuitOrigin: [
      '<strong>高要求的创造力：</strong>在创意设计团队中需要有新颖的创新点以产出作品。在这个环境中工作需要具备创新的精神、高效工作和良好的团队合作能力。对于喜欢按照一定的流程来开展工作的人来说，这可能是一个不适合的选择。',
      '<strong>极强的团队协作能力：</strong>产品开发团队需要具备良好的沟通和协作能力以及极高的专业素养，以有效地协调开展各个团队的工作，确保项目顺利进行。对于喜欢独来独往的人来说，这可能是一个不适合的选择。',
    ],
  },
  CH: {
    bgColor:
      'linear-gradient(180deg, #F5F3C9 0%, rgba(125, 170, 112, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-amber-600',
    image: ResultCImage,
    type: '稳定严谨型团队',
    tag: '严谨之王',
    desc: '根据你的测试结果，你可能是<strong>“严谨细微者”</strong>，你可能喜欢按照规定和标准进行工作，确保工作的准确性和完整性。你<strong>对细节非常敏感，能够发现并解决问题中的微小差错</strong>，以确保工作的质量和可靠性。在工作中，你严格遵守工作计划和时间表，能够<strong>按时完成任务并交付高质量的成果</strong>。你有着清晰的思维和较强的分析能力，<strong>善于进行逻辑推理和问题分解</strong>，从而理解复杂的问题并找到解决方案。你善于倾听他人的诉求并进行及时沟通，能够<strong>有效地与团队成员和其他利益相关者进行合作和协调</strong>。',
    score: [1, 5, 2, 9],
    keywords: [
      '按部就班',
      '稳定主义者',
      '熬夜冠军团',
      '合作',
      '和谐友善',
      '包容',
    ],
    generalDesc: [
      '稳定严谨型团队以精准和规律持续的特点著称。团队成员都对自己的工作持有高度的责任感，每个环节都<strong>力求精确，不容许任何错误</strong>。',
      '团队会<strong>提供必要的培训和学习机会</strong>，以便成员能够持续提升。',
      '由领导或者成员<strong>基于事实和数据</strong>共同讨论据，以做出最佳的决策。',
      '团队的奖惩方式<strong>强调公正和公平</strong>，团队成员优秀的表现会得到应有的奖励，而不良的行为则会受到惩罚。对于团队成员的考核通常是<strong>基于目标达成和工作质量来评估</strong>的。团队成员会定期进行绩效评估和反馈，以便识别优秀表现和改进机会。',
      '总的来说，稳定严谨型团队是一个<strong>专业、严谨、高效</strong>的团队，他们通过<strong>精确的工作</strong>和<strong>严谨的态度</strong>，实现团队的目标。',
    ],
    feature: [
      '工作监督制管理：稳定严谨型团队的管理者较为注重监督和控制，以确保工作按照规范进行，避免错误和风险。管理者通常会<strong>提供明确的指导和反馈，以保持团队工作的稳定性和高效性</strong>。如在生产制造团队中，团队经理会确保生产线的正常运转，监督产品质量和生产效率，以保持稳定的生产过程。',
      '工作节奏稳定有序：稳定严谨型团队通常遵循稳定有序的工作节奏，<strong>注重按时完成任务</strong>，以确保工作的高效执行和良好的组织协调。例如，在会计团队中，每个月初团队成员都会按照固定的时间表和步骤进行财务报表的编制和审核，确保准确性和实时性。',
      '工作负责：稳定严谨型团队特别注重成员对待工作的责任感，<strong>成员之间相互尊重和信任注重合作与协作，共同追求团队目标</strong>。如法律事务所的团队中，律师们之间会秉持专业精神，共同合作解决复杂的法律问题，保证客户的利益。',
      '工作规范标准：稳定严谨型团队强调规范和标准化的工作方式。团队成员<strong>遵循明确的工作程序和流程</strong>，确保工作的准确性和一致性。团队<strong>成员重视细节和准确性</strong>，避免犯错误，并通过不断的自我反思和改进来提高工作质量。例如，在制药公司的研发团队中，团队成员必须按照严格的研究流程和标准操作规程进行实验，以确保实验结果的准确性和可重复性。',
      '团队领导具有较强权威性：稳定严谨型团队的领导者通常具有稳定和权威的风格。团队<strong>领导者注重规范和正确率</strong>，具有明确的工作期望和目标，并提供清晰的指导和反馈。领导者鼓励成员遵守规则和标准，推动团队向着共同目标前进。例如：在工程项目团队中，项目经理会提供明确的指导和反馈，确保团队成员按照项目计划和工程标准进行工作，以保证项目的顺利进行。',
      '团队成员内部学习成长：稳定严谨型团队重视成员的技能和知识培养。团队<strong>成员经常接受培训和学习机会</strong>，以提高自己的专业能力和知识水平。例如：一个科研团队中，成员会定期参加学术会议、研讨会和培训课程，不断更新自己的知识，提高研究水平。',
      '团队依据集体共识决策：稳定严谨型团队通常基于团队成员之间的广泛讨论和意见交流，通过达成共识来制定决策。团队<strong>成员被鼓励提出建议和意见，并参与到决策过程中</strong>，以确保决策的准确性和可行性。在市场营销团队中，成员会针对市场调研数据进行分析和讨论，共同制定市场推广策略，以确保决策的准确性和可执行性。',
      '纯粹的合作关系：稳定严谨型团队的成员关系通常是专业和合作的。团队<strong>成员之间相互支持和信任，共同努力实现团队目标</strong>。团队成员之间的合作和协作是团队成功的关键。如咨询公司的团队中，团队成员会相互合作，分享经验和资源，共同解决复杂问题，为客户提供全面的解决方案。',
    ],
    suitTeam: [
      '<strong>项目管理部门：</strong>项目管理团队负责规划、执行和监控项目进展，需要注重细节、遵循项目管理方法和保持项目的稳定性。',
      '<strong>人力资源团队：</strong>人力资源团队负责招聘、培训发展、员工关系等人力资源管理方面的工作。',
      '<strong>行政团队：</strong>行政类部门需要按照公司的规章制度及国家的法律法规开展工作，需要有条不紊地处理事务，如人事部、财务部等。',
      '<strong>政府部门：</strong>政府部门的工作人员需要具备强烈的团队精神以及耐心，以更好的服务群众。',
      '<strong>数据分析团队：</strong>数据科学、市场研究或业务分析团队负责处理大量数据并提供准确的洞察和决策支持，需要细致入微的数据分析能力。',
    ],
    suitTeamKeys: [
      '项目管理团队',
      '人力资源团队',
      '行政团队',
      '政府部门',
      '数据分析团队',
    ],
    recommends: ['IT行业', '教育行业', '生产制造业', '医药行业', '金融行业'],
    suitOrigin: [
      '<strong>安全稳定的工作环境：</strong>你在以上或与其类似的团队中工作时，团队合作和细节管理是重要的挑战和技能。尽管工作要求具备高度的规范性和准确性，但你也会从中获得稳定性和安全感，并有机会不断发展和晋升。',
    ],
    unSuitTeam: [
      '<strong>销售团队：</strong>销售团队需要较强的沟通能力及抗压能力，与客户建立良好的关系并推动销售业绩。',
      '<strong>市场营销团队：</strong>市场营销团队负责市场推广、销售策略和客户关系管理，能够制定有效的市场营销策略并推动品牌的发展。',
      '<strong>科学研究团队：</strong>在科学领域，特别是实验室研究中，研究团队需要遵循严格的实验过程和准确的数据记录，以确保研究结果的可靠性和准确性。',
    ],
    unSuitTeamKeys: ['销售团队', '市场营销团队', '科学研究团队'],
    unSuitOrigin: [
      '<strong>高度竞争：</strong>销售团队通常存在激烈的内部及外部竞争，要求成员具备快速的反应力并能够对任务达成结果负责。对于不喜欢竞争及高压环境的人来说，这可能是一个不适合的选择。',
      '<strong>极高的专业素养：</strong>科学研究团队需要具备极高的专业素养和耐力，深耕某一领域，为社会的发展做出贡献。对于专业能力较弱的人来说，这可能是一个不适合的选择。',
    ],
  },
  HC: {
    bgColor:
      'linear-gradient(180deg, #CFF2DC 0%, rgba(97, 137, 85, 0) 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    tagColor: 'text-blue-400',
    image: ResultHImage,
    type: '精细协作型团队',
    tag: '细节狂魔',
    desc: '根据你的测试结果，你可能具备高度的责任感和自律性，你<strong>对工作的质量和准确性有很高的要求</strong>，并<strong>能够自我管理和自我激励</strong>。在工作中，你注重细节，并且能够在<strong>繁琐的工作中保持耐心和专注</strong>。你习惯于<strong>按照自己制定的计划和流程开展工作</strong>，并能够有效地管理自己的时间和任务。善于与团队成员进行开放和积极的沟通，能够分享自己的观点和经验，并倾听他人的意见和建议。你能够在团队讨论中表达自己的想法，并能够接受其他人的批评和反馈。你是<strong>细致入微且具备分析思维</strong>的人，能够独立思考和解决复杂的工作难题。你有着<strong>较强的团队意识</strong>，能够与他人合作来共同解决问题和实现团队目标。',
    score: [4, 3, 3, 7],
    keywords: [
      '和谐假面',
      '梯队明星战',
      '繁忙的马戏团',
      '工作流',
      '规章制度',
      '责任',
    ],
    generalDesc: [
      '精细协作型团队以<strong>协同合作</strong>的工作方式和<strong>细致入微</strong>的工作态度著称。',
      '这个团队的工作节奏往往是<strong>高效且精确</strong>的，团队中<strong>每个人对自己的职责有清晰的认知和定位</strong>，以保证团队的整体进度。团队成员以高效和精确为目标，注重日常工作的系统性和有序性。',
      '团队决策通常采用共识和协商的方式，<strong>每个成员都有平等的发言权</strong>。团队<strong>领导者更像是协调者和指导者</strong>，而<strong>不是命令的发布者</strong>。',
      '工作考核中则以个人的贡献为主，同时也会考虑团队整体的表现。',
      '团队成员之间建立了<strong>紧密的合作关系</strong>，相互信任和支持。总的来说，这个团队通过共享和协作，以实现团队的共同目标。',
    ],
    feature: [
      '工作协调监督管理：精细协作型团队倾向协调监督的管理方式。团队为成员设定明确的目标和期望，并<strong>提供清晰的指导和工作规范</strong>。管理者还会<strong>监控工作质量和绩效</strong>，确保团队的工作达到高标准和预期结果。如生产制造团队中，团队经理会确保生产线的正常运转，监督产品质量和生产效率，以保持稳定的生产过程。',
      '工作高效精确：精细协作型团队有着高效和精确的工作节奏。团队成员通常会设定明确的时间表和截止日期，<strong>严格按照计划工作</strong>。例如，在软件开发团队中，团队成员会根据项目里程碑制定详细的工作计划，并严格按照开发流程和时间节点进行任务分配和完成。',
      '工作和谐专注：精细协作型团队的工作氛围和谐且专注。团队成员间的互动充满了尊重和理解，<strong>每个人都致力于完成自己的工作任务</strong>，同时<strong>帮助和支持其他成员</strong>，共同努力达成目标。例如，当一项项目需要完成时，他们会共同讨论，分配任务，每个人都会全力以赴。',
      '工作中协作共享：精细协作型团队在工作中注重协作共享。团队<strong>成员之间会经常交流和分享信息</strong>，以实现最佳的工作效果。在市场营销团队中，成员们会定期举行集体讨论会，分享市场趋势和竞争动态，以便更好地制定营销策略和决策。',
      '团队领导精益求精：精细协作型团队中<strong>领导对下属的工作完成情况精益求精</strong>。如生物科技公司的领导者会在项目的每个阶段都进行详细的风险评估和管理，以确保项目的顺利进行。在研究新的生物药物过程中，团队成员需要不断地进行实验和研究并优化方案，以求达到最好的效果。',
      '团队成员成长方式多样化：精细协作型团队注重个人和团队的学习与成长。团队<strong>成员通过参与各种团队项目和任务</strong>，以及<strong>与其他成员的协作</strong>，来<strong>提升自己</strong>的技能和经验。举个例子，在研究团队中，成员们会定期参加学术会议和研讨会，与同行交流并了解最新的研究进展，以提升自己的研究水平和团队的整体实力。',
      '团队依据协商共识决策：精细协作型团队通常采用共识和协商的方式做出决策。团队<strong>成员都有平等的发言权</strong>，鼓励彼此分享意见和建议，<strong>通过讨论和反馈来达成共识</strong>。例如，在创意团队中，成员们会进行头脑风暴会议，共同讨论和决定最佳的创意方案。',
      '团队成员紧密合作：精细协作型团队成员彼此合作互助，分享知识和经验。团队成员之间的沟通密切且频繁，以便及时解决问题、协调工作和保持团队合作的动力。团队成员之间的关系<strong>不仅仅是工作伙伴，更像是朋友和伙伴</strong>。例如，他们会在工作之余，组织各种团队活动，加强团队的凝聚力和友谊。',
    ],
    suitTeam: [
      '<strong>财务部门：</strong>在会计、审计或财务分析团队中工作，能够与数字和细节密切相关，执行严格的财务流程和标准。',
      '<strong>风险管理团队：</strong>风险管理团队主要关注风险控制和合规性，确保财务交易的安全性和准确性。',
      '<strong>项目管理团队：</strong>项目管理团队负责规划、执行和监控项目进展，需要注重细节、遵循项目管理方法和保持项目的稳定性。',
      '<strong>行政团队：</strong>行政团队需要按照公司的规章制度及国家的法律法规开展工作，需要有条不紊地处理事务，如人事部、财务部等。',
      '<strong>教育培训团队：</strong>教育培训团队致力于培养人才，提供教育和培训服务，促进个人和职业发展。',
    ],
    suitTeamKeys: [
      '财务团队',
      '风险管理团队',
      '项目管理团队',
      '行政团队',
      '教育培训团队',
    ],
    recommends: [
      '金融行业',
      '法律行业',
      'IT行业',
      '教育行业',
      '生产制造业',
      '医药行业',
    ],
    suitOrigin: [
      '<strong>被流程约束的细节：</strong>你在以上或与其类似的团队中工作时，虽然会面临严格的等级和流程控制，但细致且耐心的工作状态以及良好的沟通、协作和细节管理能力将是你在这类型团队中获得成功的关键。',
    ],
    unSuitTeam: [
      '<strong>创意设计团队：</strong>广告行业的创意团队注重创意和灵感，相对更灵活，注重创新而不是细节。',
      '<strong>销售团队：</strong>销售团队需要较强的沟通能力及抗压能力，与客户建立良好的关系并推动销售业绩。',
      '<strong>市场营销团队：</strong>市场营销团队负责市场推广、销售策略和客户关系管理，能够制定有效的市场营销策略并推动品牌的发展。',
    ],
    unSuitTeamKeys: ['创意设计团队', '销售团队', '市场营销团队'],
    unSuitOrigin: [
      '<strong>灵活创新思维：</strong>在市场营销团队中工作需要创新和灵活的思维，以适应市场变化和不断改进的策略。对于喜欢遵循流程、以较为保守的思想来开展工作的人来说，这可能是一个不适合的选择。',
      '<strong>高度竞争：</strong>销售团队通常存在激烈的内部及外部竞争，工作压力大，要求成员具备快速的反应力并能够对任务达成结果负责。对于不喜欢竞争及高压环境的人来说，这可能是一个不适合的选择。',
    ],
  },
};

export const AVATAR_TYPE_AND_SIZE = {
  TYPE: ['image/jpg', 'image/png', 'image/jpeg'],
  ACCEPT: {
    'image/jpg': [],
    'image/png': [],
    'image/jpeg': [],
  },
  SIZE: 4194304,
  NAME: '4MB',
};

export const BASE_HEADER_HEIGHT = 64; //px
